module.exports = __webpack_public_path__ + "media/images/sandbox/perfect_binding_opt-c91e6942521433dcf1b9eaa48dc9b6c7.png";